// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/upload.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addcontainers {
    display: flex;
    gap: 50px;
    margin-top: 20px;
  }
  
  .infoContainer {
    flex: 1 1;
    background-color: var(--bgSoft);
    padding: 20px;
    border-radius: 10px;
    font-weight: bold;
    color: var(--textSoft);
    height: max-content;
    max-width: 350px;
    width:100%;
  }
  
  .imgContainer{
    width: 100%;
    max-height: 25rem;
    height: 16.2rem;
    position: relative;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 20px;
  }
  
  .formContainer {
    flex: 3 1;
    background-color: var(--bgSoft);
    padding: 20px;
    border-radius: 10px;
  }
  
  .form{
    display: flex;
    flex-direction: column;
  }
  
  .form input, .form textarea, .form select{
    padding: 20px;
    border: 2px solid #2e374a;
    border-radius: 5px;
    background-color: var(--bg);
    color: var(--text);
    margin: 10px 0px;
  }
  
  .form label{
    font-size: 12px;
  }
  
  .form button{
    width: 100%;
    padding: 20px;
    background-color: teal;
    color: var(--text);
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 20px;
  }

  /* hide catgeoires */
  .hide{
    height:3.3rem;
  }

  #browse::file-selector-button {
    display: none;
  }
  
  #browse {
    color: transparent;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height:2rem;
    width:2rem;
    size: fill;
  }


  .tooltip {
    position: relative;
    display: inline-block;
    border-bottom: 1px dotted black;
  }
  
  .tooltip .tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
  
    /* Position the tooltip */
    position: absolute;
    z-index: 1;
  }
  
  .tooltip:hover .tooltiptext {
    visibility: visible;
  }
  .form-control{
    background-color: #151c2c !important;
    border: 2px solid #2e374a !important;
    width: 100% !important;
    color: #ffffff !important;
  }

  .search-box{
    background-color: #141d2c !important;
    border:2px solid #2e374a !important;
    color:#ffffff;
  }`, "",{"version":3,"sources":["webpack://./src/pages/bussiness/addbusiness.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA,oBAAoB;EACpB;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAIlB,yDAAgD;IAChD,WAAW;IACX,UAAU;IACV,UAAU;EANZ;;;EAUA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;;IAEd,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,oCAAoC;IACpC,oCAAoC;IACpC,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;IACpC,mCAAmC;IACnC,aAAa;EACf","sourcesContent":[".addcontainers {\n    display: flex;\n    gap: 50px;\n    margin-top: 20px;\n  }\n  \n  .infoContainer {\n    flex: 1;\n    background-color: var(--bgSoft);\n    padding: 20px;\n    border-radius: 10px;\n    font-weight: bold;\n    color: var(--textSoft);\n    height: max-content;\n    max-width: 350px;\n    width:100%;\n  }\n  \n  .imgContainer{\n    width: 100%;\n    max-height: 25rem;\n    height: 16.2rem;\n    position: relative;\n    border-radius: 10px;\n    overflow: hidden;\n    margin-bottom: 20px;\n  }\n  \n  .formContainer {\n    flex: 3;\n    background-color: var(--bgSoft);\n    padding: 20px;\n    border-radius: 10px;\n  }\n  \n  .form{\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .form input, .form textarea, .form select{\n    padding: 20px;\n    border: 2px solid #2e374a;\n    border-radius: 5px;\n    background-color: var(--bg);\n    color: var(--text);\n    margin: 10px 0px;\n  }\n  \n  .form label{\n    font-size: 12px;\n  }\n  \n  .form button{\n    width: 100%;\n    padding: 20px;\n    background-color: teal;\n    color: var(--text);\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-top: 20px;\n  }\n\n  /* hide catgeoires */\n  .hide{\n    height:3.3rem;\n  }\n\n  #browse::file-selector-button {\n    display: none;\n  }\n  \n  #browse {\n    color: transparent;\n  }\n  \n  #browse {\n    background-image: url('../../assets/upload.jpg');\n    height:2rem;\n    width:2rem;\n    size: fill;\n  }\n\n\n  .tooltip {\n    position: relative;\n    display: inline-block;\n    border-bottom: 1px dotted black;\n  }\n  \n  .tooltip .tooltiptext {\n    visibility: hidden;\n    width: 120px;\n    background-color: black;\n    color: #fff;\n    text-align: center;\n    border-radius: 6px;\n    padding: 5px 0;\n  \n    /* Position the tooltip */\n    position: absolute;\n    z-index: 1;\n  }\n  \n  .tooltip:hover .tooltiptext {\n    visibility: visible;\n  }\n  .form-control{\n    background-color: #151c2c !important;\n    border: 2px solid #2e374a !important;\n    width: 100% !important;\n    color: #ffffff !important;\n  }\n\n  .search-box{\n    background-color: #141d2c !important;\n    border:2px solid #2e374a !important;\n    color:#ffffff;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
